export const formulaFilterOptions = Object.freeze({
  STATUS: {
    LABEL: "Status",
    placeHolder: "Status",
    options: [
      { value: "active", label: "Active" },
      { value: "inActive", label: "In Active" },
      // { value: "DELIVERED", label: "Delivered" },
    ],
  },
});

export const formulaTableDesktopHeaders = (): DesktopTableHeaderOption[] => {
  return [
    {
      text: "Active ingredients",
      span: 6,
      isCheckBox: false,
    },
    {
      text: "Cream base",
      span: 6,
      isCheckBox: false,
    },
    {
      text: " Number of times used",
      span: 4,
      isCheckBox: false,
    },
    {
      text: "Last used",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Active",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "",
      span: 2,
      isCheckBox: false,
    },
  ];
};
